import { MissionData } from '../blocks/mission'
import template from './templates/RJS06.rbxl'
import thumbnail1 from './thumbnails/RJS06/Oni.png'
import thumbnail2 from './thumbnails/RJS06/Block.png'
import thumbnail3 from './thumbnails/RJS06/Ground.png'
import thumbnail4 from './thumbnails/RJS06/Ball.png'
import thumbnail5 from './thumbnails/RJS06/SpawnLocation.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①おに',
      thumbnail: thumbnail1,
      sound: true,
    },
    {
      name: '②ブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③じめん',
      thumbnail: thumbnail3,
      sound: true,
    },
    {
      name: '④ボール',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤スタートちてん',
      thumbnail: thumbnail5,
    },
  ],
}

export default mission
